"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var checkbox_1 = require("@csod/checkbox");
var MultiselectDropdownContent = (function (_super) {
    __extends(MultiselectDropdownContent, _super);
    function MultiselectDropdownContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiselectDropdownContent.prototype.componentDidMount = function () {
        var setFocusItem = this.props.setFocusItem;
        if (setFocusItem) {
            setFocusItem(0);
        }
    };
    MultiselectDropdownContent.prototype._getListItems = function () {
        var _a = this.props, _b = _a.items, items = _b === void 0 ? [] : _b, focusedItem = _a.focusedItem, onCheckboxClick = _a.onCheckboxClick;
        return items.map(function (item, index) {
            var css = ['multiselect-item'];
            if (index === focusedItem) {
                css.push('focused');
            }
            return (React.createElement("li", { onClick: function (e) {
                    if (onCheckboxClick) {
                        onCheckboxClick(e, index);
                    }
                }, id: item.value + "--" + index, className: css.join(' '), role: "option", key: index, tabIndex: -1 },
                React.createElement(checkbox_1.default, { label: item.label, showLabel: true, isChecked: item.isChecked })));
        });
    };
    MultiselectDropdownContent.prototype._getDropdownListProps = function () {
        var _this = this;
        var _a = this.props, id = _a.id, items = _a.items, coordinates = _a.coordinates, width = _a.width, maxHeight = _a.maxHeight;
        var inlineStyles = {
            top: coordinates && coordinates.top,
            left: coordinates && coordinates.left
        };
        var classes = ['p-button-dropdown-list'];
        if ((coordinates && (coordinates.top === null && coordinates.left === null)) ||
            (items && items.length < 1)) {
            // items is empty
            classes.push('dislocated');
        }
        if (width && width !== 'Auto') {
            if (typeof width === 'number') {
                inlineStyles['width'] = width + "px";
            }
            else {
                classes.push(width.toLowerCase());
            }
        }
        if (maxHeight) {
            inlineStyles['maxHeight'] = maxHeight;
            inlineStyles['overflowY'] = 'Auto';
        }
        else {
            classes.push('no-max-height');
        }
        return {
            ref: function (c) {
                _this._listElem = c;
            },
            id: id,
            role: 'listbox',
            style: inlineStyles,
            className: classes.join(' ')
        };
    };
    MultiselectDropdownContent.prototype.render = function () {
        var _a = this.props.items, items = _a === void 0 ? [] : _a;
        if (!items.length) {
            return null;
        }
        return (React.createElement("ul", __assign({}, this._getDropdownListProps(), { tabIndex: 0 }), this._getListItems()));
    };
    return MultiselectDropdownContent;
}(React.Component));
MultiselectDropdownContent.defaultProps = {
    items: [],
    coordinates: {
        top: null,
        left: null
    },
    setFocusItem: void 0,
    width: 'Block',
    maxHeight: null
};
exports.MultiselectDropdownContent = MultiselectDropdownContent;
exports.default = MultiselectDropdownContent;
//# sourceMappingURL=MultiselectDropdownContent.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/build/control/MultiselectDropdown/MultiselectDropdownContent.js
// module id = 689
// module chunks = 0